import { Link } from '@rocketlane/rocket-router';
import { Space } from 'antd';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  Container,
  Title,
  Description,
  LinkText,
} from 'components/atoms/form-elements';
import { Layout } from 'components/atoms/layout';
import { BodyShort01 } from 'components/styles';
import { RoutePaths } from 'constant';
import { ReactComponent as PaperplaneSVG } from './paper-plane.svg';

interface Props {
  email: string | undefined;
}

const ContainerWithTopPadding = styled(Container)`
  padding-top: 200px;
`;

const PageTitle = styled(Title)`
  color: var(--black-100);
`;

const BackAction = styled.div`
  ${BodyShort01};
`;

export const SuccessPage: FC<React.PropsWithChildren<Props>> = ({ email }) => {
  return (
    <Layout>
      <ContainerWithTopPadding>
        <Space direction="vertical" size={16}>
          <PaperplaneSVG />
          <PageTitle>
            <FormattedMessage id="forgot_password.success" />
            <strong>{email}</strong>
            <br />
            <FormattedMessage id="forgot_password.success_msg" />
          </PageTitle>
          <Description>
            <FormattedMessage id="forgot_password.success_help" />
          </Description>
          <BackAction>
            <FormattedMessage
              id="forgot_password.back"
              values={{
                a: (chunks) => (
                  <Link to={RoutePaths.login}>
                    <LinkText>{chunks}</LinkText>
                  </Link>
                ),
              }}
            />
          </BackAction>
        </Space>
      </ContainerWithTopPadding>
    </Layout>
  );
};
